/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CourseDto } from './CourseDto';
import {
    CourseDtoFromJSON,
    CourseDtoFromJSONTyped,
    CourseDtoToJSON,
} from './CourseDto';
import type { DeliveryMethodDto } from './DeliveryMethodDto';
import {
    DeliveryMethodDtoFromJSON,
    DeliveryMethodDtoFromJSONTyped,
    DeliveryMethodDtoToJSON,
} from './DeliveryMethodDto';
import type { DiscountDto } from './DiscountDto';
import {
    DiscountDtoFromJSON,
    DiscountDtoFromJSONTyped,
    DiscountDtoToJSON,
} from './DiscountDto';
import type { MenuItemVariantDto } from './MenuItemVariantDto';
import {
    MenuItemVariantDtoFromJSON,
    MenuItemVariantDtoFromJSONTyped,
    MenuItemVariantDtoToJSON,
} from './MenuItemVariantDto';
import type { MenuSectionDto } from './MenuSectionDto';
import {
    MenuSectionDtoFromJSON,
    MenuSectionDtoFromJSONTyped,
    MenuSectionDtoToJSON,
} from './MenuSectionDto';
import type { OpeningHoursDto } from './OpeningHoursDto';
import {
    OpeningHoursDtoFromJSON,
    OpeningHoursDtoFromJSONTyped,
    OpeningHoursDtoToJSON,
} from './OpeningHoursDto';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';
import type { PlacementDto } from './PlacementDto';
import {
    PlacementDtoFromJSON,
    PlacementDtoFromJSONTyped,
    PlacementDtoToJSON,
} from './PlacementDto';

/**
 * 
 * @export
 * @interface LocationDtoV2
 */
export interface LocationDtoV2 {
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV2
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV2
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV2
     */
    name: string;
    /**
     * 
     * @type {Array<OpeningHoursDto>}
     * @memberof LocationDtoV2
     */
    openingHours: Array<OpeningHoursDto>;
    /**
     * 
     * @type {Array<MenuSectionDto>}
     * @memberof LocationDtoV2
     */
    sections: Array<MenuSectionDto>;
    /**
     * 
     * @type {Array<DeliveryMethodDto>}
     * @memberof LocationDtoV2
     */
    deliveryMethods: Array<DeliveryMethodDto>;
    /**
     * 
     * @type {number}
     * @memberof LocationDtoV2
     */
    id: number;
    /**
     * 
     * @type {Array<PlacementDto>}
     * @memberof LocationDtoV2
     */
    placements: Array<PlacementDto>;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV2
     */
    countryCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV2
     */
    canUseWastage: boolean;
    /**
     * 
     * @type {Array<DiscountDto>}
     * @memberof LocationDtoV2
     */
    discounts: Array<DiscountDto>;
    /**
     * 
     * @type {number}
     * @memberof LocationDtoV2
     */
    locationGroupId: number;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV2
     */
    isFoodCourt: boolean;
    /**
     * 
     * @type {Array<PaymentMethodDto>}
     * @memberof LocationDtoV2
     */
    paymentMethods: Array<PaymentMethodDto>;
    /**
     * 
     * @type {Array<CourseDto>}
     * @memberof LocationDtoV2
     */
    courses: Array<CourseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV2
     */
    isTakeAwayPreselected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV2
     */
    tableNumberRequiredForDirectSale: boolean;
    /**
     * 
     * @type {Array<MenuItemVariantDto>}
     * @memberof LocationDtoV2
     */
    componentProducts: Array<MenuItemVariantDto>;
}

/**
 * Check if a given object implements the LocationDtoV2 interface.
 */
export function instanceOfLocationDtoV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "openingHours" in value;
    isInstance = isInstance && "sections" in value;
    isInstance = isInstance && "deliveryMethods" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "placements" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "canUseWastage" in value;
    isInstance = isInstance && "discounts" in value;
    isInstance = isInstance && "locationGroupId" in value;
    isInstance = isInstance && "isFoodCourt" in value;
    isInstance = isInstance && "paymentMethods" in value;
    isInstance = isInstance && "courses" in value;
    isInstance = isInstance && "isTakeAwayPreselected" in value;
    isInstance = isInstance && "tableNumberRequiredForDirectSale" in value;
    isInstance = isInstance && "componentProducts" in value;

    return isInstance;
}

export function LocationDtoV2FromJSON(json: any): LocationDtoV2 {
    return LocationDtoV2FromJSONTyped(json, false);
}

export function LocationDtoV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationDtoV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'currency': json['currency'],
        'name': json['name'],
        'openingHours': ((json['openingHours'] as Array<any>).map(OpeningHoursDtoFromJSON)),
        'sections': ((json['sections'] as Array<any>).map(MenuSectionDtoFromJSON)),
        'deliveryMethods': ((json['deliveryMethods'] as Array<any>).map(DeliveryMethodDtoFromJSON)),
        'id': json['id'],
        'placements': ((json['placements'] as Array<any>).map(PlacementDtoFromJSON)),
        'countryCode': json['countryCode'],
        'canUseWastage': json['canUseWastage'],
        'discounts': ((json['discounts'] as Array<any>).map(DiscountDtoFromJSON)),
        'locationGroupId': json['locationGroupId'],
        'isFoodCourt': json['isFoodCourt'],
        'paymentMethods': ((json['paymentMethods'] as Array<any>).map(PaymentMethodDtoFromJSON)),
        'courses': ((json['courses'] as Array<any>).map(CourseDtoFromJSON)),
        'isTakeAwayPreselected': json['isTakeAwayPreselected'],
        'tableNumberRequiredForDirectSale': json['tableNumberRequiredForDirectSale'],
        'componentProducts': ((json['componentProducts'] as Array<any>).map(MenuItemVariantDtoFromJSON)),
    };
}

export function LocationDtoV2ToJSON(value?: LocationDtoV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'currency': value.currency,
        'name': value.name,
        'openingHours': ((value.openingHours as Array<any>).map(OpeningHoursDtoToJSON)),
        'sections': ((value.sections as Array<any>).map(MenuSectionDtoToJSON)),
        'deliveryMethods': ((value.deliveryMethods as Array<any>).map(DeliveryMethodDtoToJSON)),
        'id': value.id,
        'placements': ((value.placements as Array<any>).map(PlacementDtoToJSON)),
        'countryCode': value.countryCode,
        'canUseWastage': value.canUseWastage,
        'discounts': ((value.discounts as Array<any>).map(DiscountDtoToJSON)),
        'locationGroupId': value.locationGroupId,
        'isFoodCourt': value.isFoodCourt,
        'paymentMethods': ((value.paymentMethods as Array<any>).map(PaymentMethodDtoToJSON)),
        'courses': ((value.courses as Array<any>).map(CourseDtoToJSON)),
        'isTakeAwayPreselected': value.isTakeAwayPreselected,
        'tableNumberRequiredForDirectSale': value.tableNumberRequiredForDirectSale,
        'componentProducts': ((value.componentProducts as Array<any>).map(MenuItemVariantDtoToJSON)),
    };
}

